  
  const paymentOptions = [
    // { id: "upi", label: "UPI" },
    // { id: "paypal", label: "PayPal" },
    // { id: "payu", label: "PayU" },
    // { id: "card", label: "Credit / Debit Card" },
    // { id: "netbanking", label: "Net Banking" },
     {id:"razorpay" , label:"Razorpay"},  
    { id: "cod", label: "Cash on Delivery" },
  ];


export{
paymentOptions
  }